import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ValidationService } from '../../services/validation.service';

@Component({
  standalone: false,
  selector: 'input-errors',
  templateUrl: './input.errors.html',
})
export class InputErrors implements OnInit {
  @Input() delay = 100;
  @Input() control: AbstractControl;
  @Input() service: ValidationService;
  messages: string[] = [];

  ngOnInit() {
    if (this.delay) {
      this.control.statusChanges.pipe(debounceTime(this.delay)).subscribe(() => this.onChangeStatus());
    } else {
      this.control.statusChanges.subscribe(() => this.onChangeStatus());
    }
  }

  onChangeStatus() {
    const errors = this.control.errors;
    if (errors === null || !errors) {
      this.messages = [];
      return;
    }

    if (errors.filter && errors.max) {
      this.control.patchValue(this.control.value.substr(0, errors.required));
      return;
    }

    this.messages = [];
    for (const i in errors) {
      this.service.getTextMessage(i, errors[i]).forEach(_ => this.messages.push(_));
    }
  }
}
